export default function CsharpExamples() {
  return (
    <h2>Csharp Examples</h2>
  );
}
